<template>
  <div>
    <div class="row">
      <div class="col-sm-12 field">
        <SearchableItemParticipantPayementSelector
          ref="searchable"
          v-if="liquidation == null"
          :listTitle="'Liste des bénéficiaires'"
          :referentielName="referentielName"
          :tableFields="tableFields"
          :extraQueryArgsParamBuilder="extraQueryArgsParamBuilder"
          v-model="editableItem.beneficiaires"
          :selectable="false"
        >
          <template #listTitle>
            <slot name="listTitle">
              <h6 class="d-flex justify-content-between">
                Liste des participants
                <button
                  type="button"
                  class="style_btn btn btn-warning"
                  id="button-query"
                  @click="genererPayementPourTous()"
                >
                  Générer les lignes de paiements pour tous
                </button>
              </h6>
            </slot>
          </template>
          <template #listDescription> </template>
          <template #rowDetails="{ row }"> </template>
          <template #actions="{ data }"> </template>
        </SearchableItemParticipantPayementSelector>
        <LignePayementParEntreprise
          v-else
          ref="beneficiairePay"
          :hideButtons="liquidation.status == 'PAYE'"
          :extraQueryArg="`liquidation.id=${liquidation.id}`"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import AsyncSearchInput from "../../../../../common/AsyncSearchInput.vue";
import SearchableItemParticipantPayementSelector from "../../../../../common/SearchableItemParticipantPayementSelector.vue";
import LignePayementParEntreprise from "./LignePayementParEntreprise.vue";

export default {
  components: {
    AsyncSearchInput,
    LignePayementParEntreprise,
    SearchableItemParticipantPayementSelector,
  },
  props: {
    extraQueryArg: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "Générer un payement d'indemnité",
    },
    size: {
      type: String,
      default: "md",
    },
    typeIndemniteCode: {
      type: String,
      required: true,
    },
    entreprise: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      display: false,
      generating: false,
      liquidation: null,
      beneficiaires: [],
      editableItem: {
        modeGeneration: null,
        entreprise: null,
        beneficiaires: [],
      },
    };
  },
  watch: {
    // item: {
    //   handler() {
    //     this.editableItem = { ...this.item };
    //   },
    //   deep: true,
    // },
  },
  computed: {
    referentielName() {
      return "demandeur";
    },
    tableFields() {
      let fields = [
        "#",
        "index",
        { key: "beneficiaireNom", label: "Nom" },
        { key: "beneficiairePrenom", label: "Prénom" },
        { key: "beneficiairePhone", label: "Téléphone" },
        { key: "beneficiaireSexe", label: "Sexe" },
        { key: "statutPayement", label: "Statut Pay." },
        { key: "motifPayement", label: "Motif Pay." },
        { key: "actions", label: "Actions" },
      ];
      return fields;
    },
  },
  methods: {
    ...mapActions({
      genererPayementParEntreprise: "liquidation/genererPayementParEntreprise",
    }),
    forceReload() {
      this.$refs.searchable.reloadData();
    },
    getSelectedBeneficiaires() {
      return this.editableItem.beneficiaires;
    },
    extraQueryArgsParamBuilder() {
      //   let queryParam = `typeIndemniteCode=${this.editableItem.typeIndemniteCode}`;
      //   if (this.entreprises.length > 0) {
      //     queryParam += `&entrepriseId=${this.entreprises[0].id}`;
      //   }
      //   if (this.activePlacement != null) {
      //     queryParam += `&placementId=${this.activePlacement.id}`;
      //   }

      return this.extraQueryArg;
    },
    async genererPayementPourTous() {
      if (this.$refs.searchable.isEmpty) {
        this.$toast.error("Aucun impayé trouvé. Pas besoin de générer.", {
          position: "top-right",
          duration: 8000,
        });
      }

      await this.$confirm.require({
        group: "confirmDialog",
        message: `Voulez-vous vraiment générer les ${this.typeIndemniteCode} pour tous les bénéficiaires ayant pris service dans l'entreprise ${this.entreprise.raisonSocial} ?`,
        header: "Confirmation",
        icon: "pi pi-exclamation-triangle",
        accept: () => {
          this.generating = true;
          this.genererPayementParEntreprise({
            modeGeneration: "FULL",
            typeIndemniteCode: this.typeIndemniteCode,
            entreprise: this.entreprise,
          })
            .then((data) => {
              if (data != null && data.content != null && data.content.length > 0) {
                this.liquidation = data.content[0].liquidation;
              }

              this.generating = false;
              this.successfullyGenerated = true;
              this.$toast.success("Payement généré avec succès!", {
                position: "top-right",
                duration: 8000,
              });
            })
            .catch(() => {
              this.$toast.error("Opération non réussi!", {
                position: "top-right",
                duration: 8000,
              });
            });
        },
      });
    },
  },
};
</script>

<style>
.field-checkbox,
.field-radiobutton {
  display: flex;
  justify-items: center;
}
.stepper-dialog .p-dialog-header-icons {
  display: none;
}

.stepper-dialog .p-dialog-content {
  background: #faf4fa;
}

.stepper-dialog .p-dialog-footer {
  box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.2), 0px -1px 1px rgba(0, 0, 0, 0.2);
}

.stepper-dialog .p-dialog-header {
  box-shadow: 1px 2px 0px 0px rgba(0, 0, 0, 0.5);
}

.shadow-light {
  box-shadow: 0 0.5rem 1rem rgb(0 0 0 / 3%) !important;
}

.msg-cloture.p-message .p-message-wrapper {
  padding: 0.5rem 1.2rem;
}
</style>
